<template>
    <marquee class="announcement-msg deposit-marquee-text mt-1" v-if="config?.announcement?.value" scrollamount="3">
        {{config?.announcement?.value}}
    </marquee>
   <router-view v-if="init" :key="$route.fullPath"></router-view>
</template>

<script>
import { computed } from 'vue';
import marquee from '@/shared/services/marqueeService';
import { getWalletAuth} from '../services/module';
export default {
    name: "WalletModule",
    data() {
        return {
            init: false,
            config: null
        }
    },
    components:{
        marquee
    },
    provide() {
        return { 
            walletConfig : computed(() => this.config),
            onlyBank: computed(() => !!this.config?.agents?.find(agent => agent == this.$auth?.user?.cpi) || false),
        }
    },
    created() {
        // this.getWalletAuth();
        if(!this.$auth?.user?.isDemo){
            this.getWalletAuth();
        }else{
            this.$errorToast('Wallet access is restricted for demo users')
            this.$router.push('/')
        }
    },
    methods: {

        async getWalletAuth(){
            try {
                let response = await getWalletAuth();
                if(response?.data){
                    this.config = response.data
                    this.init = true
                }
            } catch (error) {
                this.$errorToast(error)
            }
        }
    }
}
</script>